import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import SET_BASE_URL from './types';
export default _defineProperty({}, SET_BASE_URL, function (state, payload) {
  var currentState = state;
  currentState.baseURL = payload;
});